
import React from "react";



const ComponentLoader = () => {
	

 


	return (

<div 

className=""
style={{

            alignItems: 'center',
            display: "flex",
            justifyContent:'center'
  

			}}>

<div className="loading-wave">
  <div className="loading-bar"></div>
  <div className="loading-bar"></div>
  <div className="loading-bar"></div>
  <div className="loading-bar"></div>
</div>

</div>	
	
	);
};

export default ComponentLoader;
